import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { ViewReadSadhanaPage } from '../view-read-sadhana/view-read-sadhana';
import { Sadhona } from '../../providers/sadhona';

/**
 * Generated class for the MenteeApproveSadhanaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-mentee-approve-sadhana',
  templateUrl: 'mentee-approve-sadhana.html',
})
export class MenteeApproveSadhanaPage {

  sadhanaData: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, private sadhona: Sadhona,
    private alertCtrl: AlertController) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MenteeApproveSadhanaPage');
    this.approvedSadhanaData()
  }

  approvedSadhanaData() {
    this.sadhona.approvedSadhanaData().subscribe(
      res => {
        this.sadhanaData = res['data']
      },
      err => {
        this.presentAlert('Alert Message', 'something went wrong ,try again')
      }
    )
  }

  viewSadhana(item) {
    console.log(item)
    this.navCtrl.push(ViewReadSadhanaPage, {
      userid: item.userid,
      month: item.sadhanamonth,
      year: item.sadhanayear,
      sequencenumber: item.sequencenumber,
      mentorname: item.mentorsurname + ' ' + item.mentorforename
    })
  }

  presentAlert(title, msg) {

    let alert = this.alertCtrl.create({
      title: title,
      subTitle: msg,
      buttons: [{
        text: 'Dismiss',
      }],
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/mentee-approve-sadhana/mentee-approve-sadhana.ts